import { createContext, MutableRefObject, useContext } from "react";

import { LibSvgRenderer } from "features/engine2D/svgRenderer";

export const SvgRendererContext = createContext<MutableRefObject<LibSvgRenderer | null>>({ current: null });

export function useSvgRenderer() {
    return useContext(SvgRendererContext);
}
